import { useId } from 'react'
import { CalendarIcon, ChevronDownIcon } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import { EMPTY_DATE_RANGE, PERIOD_LABEL, hasDateRange } from '@/lib/filters'
import type { DateRange } from '@/lib/filters'

interface PeriodMenuProps {
  range: DateRange
  onChange: (next: DateRange) => void
}

export function PeriodMenu({ range, onChange }: PeriodMenuProps): React.ReactElement {
  const fromId = useId()
  const toId = useId()
  const canClear = hasDateRange(range)

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
        >
          <CalendarIcon />
          {PERIOD_LABEL}
          <ChevronDownIcon className="opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-60 space-y-3"
      >
        <div className="space-y-1.5">
          <Label htmlFor={fromId}>Från</Label>
          <Input
            id={fromId}
            type="date"
            value={range.from}
            max={range.to || undefined}
            onChange={(event) => onChange({ ...range, from: event.target.value })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor={toId}>Till</Label>
          <Input
            id={toId}
            type="date"
            value={range.to}
            min={range.from || undefined}
            onChange={(event) => onChange({ ...range, to: event.target.value })}
          />
        </div>
        {canClear && (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            className="w-full"
            onClick={() => onChange(EMPTY_DATE_RANGE)}
          >
            Rensa period
          </Button>
        )}
      </PopoverContent>
    </Popover>
  )
}
